module.exports = __webpack_public_path__ + "img/support-adv-04.c85088c3.png";